import apiClient from "../ApiClient";

const taskService = () => {
  const { request } = apiClient();

  const taskList = async (paginationFilterData) => {
    try {
      return await request("POST", "/tasks/task-list", paginationFilterData);
    } catch (error) {
      console.error("Failed to fetch tasks:", error.message);
      throw error;
    }
  };

  const getTaskStatuses = async () => {
    try {
      return await request("GET", "/tasks/task-statuses");
    } catch (error) {
      console.error("Failed to fetch task statuses:", error.message);
      throw error;
    }
  };

  const deleteTask = async (data) => {
    try {
      return await request("POST", "/tasks/delete-task", data);
    } catch (error) {
      console.error("Failed to delete task:", error.message);
      throw error;
    }
  };

  const createTask = async (taskData) => {
    try {
      return await request("POST", "/tasks/create-task", taskData);
    } catch (error) {
      console.error("Failed to create task:", error.message);
      throw error;
    }
  };

  const taskDetails = async (taskData) => {
    try {
      return await request("POST", "/tasks/task-details", taskData);
    } catch (error) {
      console.error("Failed to get task details:", error.message);
      throw error;
    }
  };


  const updateTask = async (taskData) => {
    try {
      return await request("POST", "/tasks/update-task", taskData);
    } catch (error) {
      console.error("Failed to create task:", error.message);
      throw error;
    }
  };


  return { 
    taskList, 
    getTaskStatuses,
    deleteTask,
    createTask,
    taskDetails,
    updateTask,
  };
};
export default taskService;
